import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Info } from '../components/fragments/Info';
import { Title } from '../components/fragments/Title';
import { ConsultaUsuarioInmuebleComponent } from '../components/ConsultaUsuarioInmuebleComponent';
import { ScrollToTop } from '../components/shared/ScrollToTop';

export const ConsultaUsuarioInmueble: React.FC = () => {

    return (
        <>
            <ScrollToTop />
            <Container>
                <VStack>
                    <VStack>
                        <Box flexDirection={['column', 'row']}>
                            <Box>
                                <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>

                                    <Title title={'Solicitud de contacto por Inmuebles'}></Title>

                                    <br />

                                    <Info info={'Si estás interesado en consultar por el inmueble, dejanos tus datos y te contactaremos.'}></Info>
                                </VStack>
                            </Box>
                            <Box
                                width={["100%", "90%", "85%", "65%"]}
                                p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                                mr={["0px", "15px", "20px", "50px"]}
                                bg="secondary.2"
                                minHeight={["400px", "500px", "500px"]}>
                                <ConsultaUsuarioInmuebleComponent />
                            </Box>
                        </Box>
                    </VStack>

                </VStack>
            </Container>
        </>
    )
};